<template>
  <template-corporation
    :pathName="pathName"
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
  >
  </template-corporation>
</template>

<script>
export default {
  name: "CorpRegisteredWithVat",
  props: ["hasFinalTaxType"],
  data() {
    return {
      pathName: "corp_registered_with_vat",
      fact: [
        "คุณจะมีค่าใช้จ่ายเพิ่มเติมที่ตามมาหลังจด VAT คือค่าใช้จ่ายในการทำบัญชีและตรวจสอบบัญชี",
        "การจด VAT ช่วยให้คุณมีหลักฐานในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
      ],
    };
  },
};
</script>

<style scoped></style>
